import { setter } from './utils';
import { SET_TOOLBAR_LIST_CONTAINER_WIDTH } from '../actions/types';

export default setter(SET_TOOLBAR_LIST_CONTAINER_WIDTH, 0);
